/* eslint-disable class-methods-use-this */

import { canUseDOM } from '@/app/common/utils/canUseDOM';

export default class Device {
  private readonly userAgent: string;
  constructor(userAgent: string) {
    this.userAgent = userAgent;
  }

  get appVersion(): string {
    return (
      (canUseDOM && 'navigator' in window && 'appVersion' in navigator && navigator.appVersion.toLowerCase()) || ''
    );
  }

  get isWindows(): boolean {
    return /win/i.test(this.appVersion);
  }

  get isIphone(): boolean {
    return /iphone/i.test(this.userAgent);
  }

  get isIpod(): boolean {
    return /ipod/i.test(this.userAgent);
  }

  get isAndroidPhone(): boolean {
    return /android/i.test(this.userAgent) && /mobile/i.test(this.userAgent);
  }

  get isBlackberry(): boolean {
    return /blackberry/i.test(this.userAgent) || /BB10/i.test(this.userAgent);
  }

  get isWindowsPhone(): boolean {
    return this.isWindows && /phone/i.test(this.userAgent);
  }

  get isIpad(): boolean {
    return !!(
      /ipad/i.test(this.userAgent) ||
      (canUseDOM &&
        'navigator' in window &&
        /Macintosh/i.test(navigator.userAgent) &&
        navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 1)
    );
  }

  get isAndroidTablet(): boolean {
    return /android/i.test(this.userAgent) && !/mobile/i.test(this.userAgent);
  }

  get isWindowsTablet(): boolean {
    return this.isWindows && !this.isWindowsPhone && /touch/i.test(this.userAgent);
  }

  get isTouchable(): boolean {
    return canUseDOM ? 'ontouchstart' in window || navigator.maxTouchPoints > 0 : false;
  }

  get isTouchableTablet(): boolean {
    return this.isTouchable && !this.isMobile;
  }

  get isMobile(): boolean {
    return this.isIphone || this.isIpod || this.isAndroidPhone || this.isBlackberry || this.isWindowsPhone;
  }

  get isDesktop(): boolean {
    return !this.isMobile && !this.isTablet;
  }

  get isTablet(): boolean {
    return this.isIpad || this.isAndroidTablet || this.isWindowsTablet || this.isTouchableTablet;
  }

  getDeviceType() {
    if (this.isMobile) {
      return 'mobile';
    }
    if (this.isTablet) {
      return 'tablet';
    }
    return 'desktop';
  }
}
